<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        Change Request Component
        <p class="pl-4">|</p>
      </h1>
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="grid"
        >List</vs-button
      >
      <p class="pr-4"></p>
      <!-- <vs-button color="success" type="filled" icon="add" @click="cusAdd"
        >Add</vs-button
      > 
      <vs-dropdown>
        <vs-button
          class="btn-drop"
          type="filled"
          icon="more_horiz"
          color="success"
          >Add</vs-button
        >
        <vs-dropdown-menu>
          <vs-dropdown-item @click="cusAddEdit">Edit</vs-dropdown-item>
          <vs-dropdown-item @click="cusAdd">Add</vs-dropdown-item>
          <vs-dropdown-item @click="cusAddCancel">Cancel</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <p class="pr-4"></p>-->
      <vs-button
        color="success"
        type="filled"
        icon="create"
        @click="cusEdit"
        v-if="btndis3"
        >View</vs-button
      >
      <p class="pr-4"></p>
      <!-- <vs-button
        color="danger"
        type="filled"
        icon="remove_circle_outline"
        @click="cusDel"
        v-if="btndis2"
        >Delete</vs-button
      >
      <p class="pr-4"></p> -->
      <vs-button
        color="#5b3cc4"
        type="filled"
        icon="list"
        @click="goApprove"
        v-if="btndis2"
        >Approve</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="danger"
        type="filled"
        icon="list"
        @click="goReject"
        v-if="btndis2"
        >Reject</vs-button
      >
      <!--<p class="pr-4"></p>
      <vs-button
        color="success"
        type="filled"
        icon="list"
        @click="goDetail"
        v-if="btndis"
        >Detail</vs-button
      >
      <p class="pr-4"></p> -->
    </div>

    <transition-group
      enter-active-class="animated lightSpeedIn"
      leave-active-class="animated lightSpeedOut"
    >
      <putadd
        v-if="addshow"
        key="addshow"
        :acstate="acstate"
        :recid="recid"
        @grid="grid"
        :companyGroupsCode="companyGroupsCode"
        :businessPartnersCode="businessPartnersCode"
      ></putadd>
      <addcancel
        v-if="addcancelshow"
        key="addcancelshow"
        :acstate="acstate"
        :recid="recid"
        @grid="grid"
        :companyGroupsCode="companyGroupsCode"
        :businessPartnersCode="businessPartnersCode"
      ></addcancel>
      <addadd
        v-if="addaddshow"
        key="addaddshow"
        :acstate="acstate"
        :recid="recid"
        @grid="grid"
        :companyGroupsCode="companyGroupsCode"
        :businessPartnersCode="businessPartnersCode"
      ></addadd>
      <addedit
        v-if="addeditshow"
        key="addeditshow"
        :acstate="acstate"
        :recid="recid"
        @grid="grid"
        :companyGroupsCode="companyGroupsCode"
        :businessPartnersCode="businessPartnersCode"
      ></addedit>
      <viewchange
        v-if="viewchangeshow"
        key="viewchangeshow"
        :acstate="acstate"
        :recid="recid"
        @grid="grid"
        :companyGroupsCode="companyGroupsCode"
        :businessPartnersCode="businessPartnersCode"
      ></viewchange>
      <viewrevoke
        v-if="viewrevokeshow"
        key="viewrevokeshow"
        :acstate="acstate"
        :recid="recid"
        @grid="grid"
        :companyGroupsCode="companyGroupsCode"
        :businessPartnersCode="businessPartnersCode"
      ></viewrevoke>
      <aggrid
        v-if="gridshow"
        :key="gridshow"
        :masrec="masrec"
        @recsel="recsel"
        :companyGroupsCode="companyGroupsCode"
        :businessPartnersCode="businessPartnersCode"
      ></aggrid>
    </transition-group>
    <vs-popup title="ชื่อเจ้าหน้าที่" :active.sync="popupActive2">
      <!-- <vs-input
        class="w-full mb-6"
        placeholder="ผู้อนุมัติ"
        v-model="approval"
      />
      <vs-button
        v-if="validName"
        color="success"
        type="filled"
        icon="check"
        @click="acceptConfirm"
        >Approve</vs-button
      > -->
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span>ผู้อนุมัติ</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="approval"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span>เหตุผล</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="areason"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span></span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-button
              v-if="validName"
              color="success"
              type="filled"
              icon="check"
              @click="acceptConfirm"
              >Approve</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="ชื่อเจ้าหน้าที่" :active.sync="popupActive3">
      <!-- <vs-input
        class="w-full mb-6"
        placeholder="ผู้ยกเลิก"
        v-model="rejector"
      />
      <vs-button
        v-if="validName2"
        color="success"
        type="filled"
        icon="x"
        @click="acceptReject"
        >Reject</vs-button
      > -->
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span>ผู้ยกเลิก</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="rejector"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span>เหตุผล</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="areason"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span></span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-button
              v-if="validName2"
              color="danger"
              type="filled"
              icon="flag"
              @click="acceptReject"
              >Reject</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
// import aggrid from "./DataTable/AgGrid";
import aggrid from "./grid";
import putadd from "./putadd";
import addcancel from "./addcancel.vue";
import addadd from "./inbdadd.vue";
import addedit from "./addedit.vue";
import viewchange from "./viewchange.vue";
import viewrevoke from "./viewrevoke.vue";

import pdfMake from "pdfmake";
import pdfFonts from "../../../assets/custom-fonts";
import axios from "axios";
import { BASE_API_URL, ENV_CHECK } from "@/constants/index.ts";

export default {
  data() {
    return {
      fdtype: "",
      popupActive2: false,
      popupActive3: false,
      approval: "",
      rejector: "",
      areason: "",
      changeType: "",
      refnum: "",
      arData: [],
      businessPartnersCode: "",
      userid: "",
      companyGroupsCode: "",
      viewrevokeshow: false,
      viewchangeshow: false,
      addeditshow: false,
      addaddshow: false,
      addcancelshow: false,
      addshow: false,
      gridshow: false,
      btndis: false,
      btndis2: false,
      btndis3: false,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
      masrec: null,
      fabact: [
        { act: "cusAdd", label: "Add" },
        { act: "cusEdit", label: "Edit" },
        { act: "cusDel", label: "Delete" },
        { act: "goPrint", label: "PrintQR" },
        { act: "goDetail", label: "Inbdetails" },
        { act: "hideFab", label: "Hide" },
      ],
    };
  },
  computed: {
    validName() {
      return this.approval.length > 0;
    },
    validName2() {
      return this.rejector.length > 0;
    },
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    handle_function_call(function_name) {
      this[function_name]();
    },
    recsel(val, val2, val3, val4) {
      // console.log(val);
      // console.log(val2);
      // console.log(val3);
      // console.log(val4);

      this.btndis = true;
      this.recid = val;
      if (val2 == "APPROVED" || val2 == "REJECTED") {
        this.btndis2 = false;
      } else {
        this.btndis2 = true;
      }
      this.btndis3 = true;
      this.changeType = val3;
      this.refnum = val4;
      // alert(this.refnum.substring(0,2))
      if (
        this.refnum.substring(0, 2) == "BM" ||
        this.refnum.substring(0, 2) == "DM" ||
        this.refnum.substring(0, 2) == "AM" ||
        this.refnum.substring(0, 2) == "SM" ||
        this.refnum.substring(0, 2) == "TM"
      ) {
        this.fdtype = "inbound";
        // alert(this.fdtype);
      } else if (
        this.refnum.substring(0, 2) == "MB" ||
        this.refnum.substring(0, 2) == "MD" ||
        this.refnum.substring(0, 2) == "MT"
      ) {
        this.fdtype = "outbound";
        // alert(this.fdtype);
      }
    },
    cusAdd() {
      this.recid = 0;
      this.addshow = true;
      this.viewchangeshow = false;
      this.addcancelshow = false;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "ADD";
      this.viewrevokeshow = false;
    },
    cusAddEdit() {
      this.recid = 0;
      this.viewchangeshow = false;
      this.addcancelshow = true;
      this.addshow = false;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "ADD";
      this.viewrevokeshow = false;
    },
    cusAddCancel() {
      this.recid = 0;
      this.viewchangeshow = false;
      this.addcancelshow = true;
      this.addaddshow = false;
      this.addshow = false;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "ADD";
      this.viewrevokeshow = false;
    },
    grid() {
      this.viewchangeshow = false;
      this.addshow = false;
      this.addeditshow = false;
      this.addcancelshow = false;
      this.addaddshow = false;
      this.gridshow = false;
      this.viewrevokeshow = false;
      setTimeout(() => {
        this.gridshow = true;
      }, 400);
      this.btndis = false;
      // this.$store.dispatch("setReportGrid", 0);
    },
    goApprove() {
      this.areason = "";
      this.approval = "";
      this.popupActive2 = true;
    },
    async acceptConfirm() {
      // console.log(this.approval);

      this.popupActive2 = false;
      this.btndis = false;
      this.btndis2 = false;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        const moment = require("moment-timezone");
        const timezone = "Asia/Bangkok";

        // Get the current date and time in the specified timezone
        const now = moment().tz(timezone);

        if (token) {
          const formData = {
            number: this.recid,
            approval: this.approval,
            areason: this.areason,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
            createdAt: now,
          };

          if (this.changeType == "CANCEL") {
            const response = await axios.post(
              `${BASE_API_URL}/inbound-svc/chrequests/approveCancel`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
            // console.log(response.data);

            if (response.data.status != "success") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response.data.message,
              });
            } else {
              if (this.$store.state.reportgrid == 0) {
                this.$store.dispatch("setReportGrid", 1);
              } else {
                this.$store.dispatch("setReportGrid", 0);
              }

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Approved Complete",
                text: response.data.message,
              });
            }
          } else if (this.changeType == "ADD") {
            const response = await axios.post(
              `${BASE_API_URL}/inbound-svc/chrequests/approveAdd`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
            // console.log(response.data);

            if (response.data.status != "success") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response.data.message,
              });
            } else {
              if (this.$store.state.reportgrid == 0) {
                this.$store.dispatch("setReportGrid", 1);
              } else {
                this.$store.dispatch("setReportGrid", 0);
              }

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Approved Complete",
                text: response.data.message,
              });
            }
          } else if (this.changeType == "EDIT") {
            const response = await axios.post(
              `${BASE_API_URL}/inbound-svc/chrequests/approveEdit`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
            // console.log(response.data);

            if (response.data.status != "success") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response.data.message,
              });
            } else {
              if (this.$store.state.reportgrid == 0) {
                this.$store.dispatch("setReportGrid", 1);
              } else {
                this.$store.dispatch("setReportGrid", 0);
              }

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Approved Complete",
                text: response.data.message,
              });
            }
          } else if (this.changeType == "CHANGE") {
            const response = await axios.post(
              `${BASE_API_URL}/inbound-svc/chrequests/approveChange`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
            // console.log(response.data);

            if (response.data.status != "success") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response.data.message,
              });
            } else {
              if (this.$store.state.reportgrid == 0) {
                this.$store.dispatch("setReportGrid", 1);
              } else {
                this.$store.dispatch("setReportGrid", 0);
              }

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Approved Complete",
                text: response.data.message,
              });
            }
          } else if (this.changeType == "REVOKE") {
            const response = await axios.post(
              `${BASE_API_URL}/inbound-svc/chrequests/approveRevoke`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
            // console.log(response.data);

            if (response.data.status != "success") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response.data.message,
              });
            } else {
              if (this.$store.state.reportgrid == 0) {
                this.$store.dispatch("setReportGrid", 1);
              } else {
                this.$store.dispatch("setReportGrid", 0);
              }

              if (ENV_CHECK == "PROD") {
                this.submitFDMS(this.recid);
              }

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Approved Complete",
                text: response.data.message,
              });
            }
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
      // this.gridshow = false;
      // this.gridshow = true;
    },
    async submitFDMS(ReferenceNumber) {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const formData2 = {
          number: ReferenceNumber,
          ReferenceNumber: this.refnum,
          editor: String(this.userid),
          type:this.fdtype
        };

        const response2 = await axios.post(
          `${BASE_API_URL}/inbound-svc/chrequests/submitFDMSRevoke`,
          formData2,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        // console.log(response2)

        if (response2.data.status != "success") {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Submit to FDMS",
            text: response2.data.message,
            fixed: true,
          });
        } else {
          this.$vs.notify({
            position: "top-right",
            color: "success",
            title: "Success",
            text: response2.data.message,
          });
        }
      } catch (error) {
        alert("กรุณาเข้าระบบอีกครั้ง");
      }
    },
    goReject() {
      this.areason = "";
      this.rejector = "";
      this.popupActive3 = true;
    },
    async acceptReject() {
      // console.log(this.approval);
      this.popupActive3 = false;
      this.btndis = false;
      this.btndis2 = false;
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        const moment = require("moment-timezone");
        const timezone = "Asia/Bangkok";

        // Get the current date and time in the specified timezone
        const now = moment().tz(timezone);

        if (token) {
          const formData = {
            number: this.recid,
            rejector: this.rejector,
            areason: this.areason,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
            createdAt: now,
          };

          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/chrequests/chReject`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Rejected Complete",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
      // this.gridshow = false;
      // this.gridshow = true;
    },
    goDetail() {
      this.btndis = true;
      this.$router.replace("/dtomovesdetails/" + this.recid);
    },
    goDate() {
      let today = new Date();
      let dd = today.getDate();

      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }
      this.daday = dd;
      this.damonth = mm;
      this.dayear = Number(yyyy) + 543;
      this.dtoday = dd + "-" + mm + "-" + yyyy;
    },
    getArraySep(data) {
      // console.log(data);
      this.arData = [];

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: i,
            fontSize: 10,
            bold: true,
            alignment: "center",
          },
          {
            text: item.cmansNumber,
            fontSize: 10,
            bold: true,
            alignment: "center",
          },
          {
            text: item.description,
            fontSize: 10,
            bold: true,
            alignment: "left",
          },
          {
            text:
              this.formatnumber(item.totalpckamount) + " " + item.totalpckunit,
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
          {
            text: this.formatnumber(item.totalgw) + " " + item.totalgwunit,
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
        ]);

        i++;
        // console.log(item.totalgw);
      });
    },
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    getBase64ImageFromURL(url) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          // var dataURL = canvas.toDataURL("image/png");
          var dataURL = canvas.toDataURL("image/png");

          resolve(dataURL);
        };

        img.onerror = (error) => {
          reject(error);
        };

        img.src = url;
      });
    },
    getArray(data) {
      // console.log(data);
      this.arData = [];

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: i,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbordersnumber,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbitemnum,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.mawb,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.hawb,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.invnum,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbdetailsSkuscode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.edescription,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: this.formatnumber(item.itempck),
            fontSize: 10,
            bold: false,
            alignment: "right",
          },
          {
            text: item.fcompanyGroupsCode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.tcompanyGroupsCode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
        ]);

        i++;
        // console.log(i);
      });
    },
    cvDate(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    async goPrint() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        this.loading = true;

        if (token) {
          const formData = {
            companyGroupsCode: this.companyGroupsCode,
            number: this.recid,
            // from: '2022-01-11'
          };
          // const response = await axios.post(`${BASE_API_URL}/agents/findall`, formData);

          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/moves/printMoves`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          // console.log(response.data.status);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            // console.log(response.data);

            this.getArray(response.data.movesDetails);

            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "landscape",

              footer: {
                // columns: [
                //   "Left part",
                //   { text: "Right part", alignment: "right" },
                // ],
                columns: [
                  [
                    {
                      text: "พิมพ์ ณ วันที่ " + this.cvDate(new Date()),
                      fontSize: 14,
                      alignment: "right",
                      // [left, top, right, bottom]
                      // margin: [100, -20, 0, 0],
                      margin: [0, 0, 10, 0],
                    },
                  ],
                ],
              },

              content: [
                {
                  text: "ใบสั่งการย้ายสินค้าระหว่างผู้ประกอบการ",
                  style: "title",
                  // [left, top, right, bottom]
                  margin: [0, -20, 0, 0],
                },
                {
                  text: "ใบย้ายสินค้าเลขที่ " + response.data.movesNumber,
                  style: "subtitle",
                  margin: [0, 0, 0, 10],
                },
                {
                  table: {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 1,
                    widths: [25, 70, 45, 60, 60, 60, 80, 125, 45, 60, 60], // 525(portrait) 700(landscape)
                    body: [
                      [
                        {
                          text: "ลำดับ",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Inbound Number",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Inbound Item",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "MAWB",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "HAWB",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "INVOICE",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Product Code",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Description",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Package",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "From DTO",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "To DTO",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [25, 70, 45, 60, 60, 60, 80, 125, 45, 60, 60], // 525(portrait) 700(landscape)
                    // body: this.getArray(res.data.message),
                    body: this.arData,
                    // body: [[{}, {}, {}, {}, {},{}, {}, {}]],
                  },
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 18,
                  bold: true,
                  alignment: "center",
                },
                subtitle: {
                  fontSize: 16,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/pages/login/");
      }
    },
    cusEdit() {
      // this.addshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "EDIT";
      if (this.changeType == "CANCEL") {
        this.addcancelshow = true;
        this.addaddshow = false;
        this.addeditshow = false;
        this.viewchangeshow = false;
        this.viewrevokeshow = false;
      } else if (this.changeType == "ADD") {
        this.addaddshow = true;
        this.addeditshow = false;
        this.addcancelshow = false;
        this.viewchangeshow = false;
        this.viewrevokeshow = false;
      } else if (this.changeType == "EDIT") {
        this.addeditshow = true;
        this.addaddshow = false;
        this.addcancelshow = false;
        this.viewchangeshow = false;
        this.viewrevokeshow = false;
      } else if (this.changeType == "CHANGE") {
        this.viewchangeshow = true;
        this.addeditshow = false;
        this.addaddshow = false;
        this.addcancelshow = false;
        this.viewrevokeshow = false;
      } else if (this.changeType == "REVOKE") {
        this.viewchangeshow = false;
        this.addeditshow = false;
        this.addaddshow = false;
        this.addcancelshow = false;
        this.viewrevokeshow = true;
      }
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Delete? " + this.recid,
        accept: this.acceptAlert,
      });
    },
    async acceptAlert() {
      this.btndis = false;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/chrequests/deleteCancel`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Deleted Complete",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          // this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  mounted() {
    this.checkProfiles();
    // console.log(this.$acl.check('admin'));
  },
  components: {
    aggrid,
    putadd,
    addcancel,
    addadd,
    addedit,
    viewchange,
    viewrevoke,
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
</style>
